import SectionHeader from "./SectionHeader";
import Reveal from "./Reveal";
import { Calendar, ClipboardList, Wrench, ShieldCheck, RotateCcw } from "lucide-react";

const steps = [
  { icon: Calendar, n: "01", t: "BOOK", d: "Tell us about the property — type, location, size and what you're seeing. We'll confirm an appointment window that works for you." },
  { icon: ClipboardList, n: "02", t: "PREPARE", d: "You'll receive clear preparation instructions covering bedding, furniture, access to treatment areas and leaving the property during treatment." },
  { icon: Wrench, n: "03", t: "TREAT", d: "Our technician arrives at the scheduled time and performs the bed bug treatment across the agreed areas of the property." },
  { icon: ShieldCheck, n: "04", t: "FOLLOW THE AFTERCARE", d: "Follow the post-treatment instructions — when to re-enter, how to handle treated surfaces and what to do with bedding and belongings." },
  { icon: RotateCcw, n: "05", t: "FOLLOW-UP", d: "Where the program calls for it, we arrange the appropriate follow-up treatment to help break the bed bug life cycle." }
];

export default function TreatmentExperience() {
  return (
    <section id="treatment" className="border-b border-border bg-background px-5 py-24 lg:px-8 lg:py-32">
      <div className="mx-auto max-w-7xl">
        <SectionHeader
          kicker="The Treatment Experience"
          title="SIMPLE FOR YOU. SERIOUS FOR US."
          subtitle="No inspection step. No back-and-forth. A clear, deliberate path from booking to follow-up."
        />
        <div className="mt-16 grid gap-px overflow-hidden rounded-lg border border-border bg-border sm:grid-cols-2 lg:grid-cols-5">
          {steps.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.05}>
              <div className="group h-full bg-background p-7 transition-colors hover:bg-muted/40">
                <div className="flex items-center justify-between">
                  <span className="font-heading text-3xl font-extrabold text-muted-foreground/40 tnum">{s.n}</span>
                  <s.icon className="h-5 w-5 text-accent" />
                </div>
                <div className="mt-8 h-px w-8 bg-accent transition-all group-hover:w-12" />
                <h3 className="mt-5 font-heading text-sm font-bold tracking-[0.18em]">{s.t}</h3>
                <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{s.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}